import router from "@/router";
const user = {
  namespaced: true,
  state: {
    token: "", // 用户token
    userInfo: null, // 用户信息
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_USER_INFO: (state, data) => {
      state.userInfo = data;
    },
  },

  actions: {
    // 登录存储信息
    LoginActions({ state, commit }, data) {
      console.log("登录存储信息", data);
      const isLogin = state.token;
      return new Promise((resolve, reject) => {
        if (!isLogin && isLogin === undefined) {
          resolve();
        } else {
          commit("SET_TOKEN", data.token);
          commit("SET_USER_INFO", data);
          resolve(data);
        }
      });
    },
    // 退出登陆
    LogoutSystem({ dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch("clearUserInfo");
        resolve();
      });
    },
    // 清除缓存
    clearUserInfo({ commit }) {
      commit("SET_TOKEN", "");
      commit("SET_USER_INFO", null);
      router.replace("/");
    },
  },
};

export default user;
